<div fxLayout="row" fxLayoutAlign="start center">
  <div class="searchbar" fxLayout="row" fxLayoutAlign="center center" fxFlex="grow">
    <!-- SEARCH FIELD -->
    <div fxFlex="grow">
      <input
        matInput
        type="text"
        id="query"
        placeholder="Ich suche nach..."
        [(ngModel)]="query"
        (ngModelChange)="preflightSearch()"
        [matAutocomplete]="auto"
        (keyup.enter)="blur($event)"
        (blur)="searchBlur($event)"
      />

      <!-- preflight search results -->
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of preflightValues" [value]="option" [innerHTML]="option | safeHTML">
        </mat-option>
      </mat-autocomplete>
    </div>

    <!-- SEARCH BUTTON  -->
    <button fxFlex="noshrink" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <!-- no click necessary - click here means blur on search input ;) -->
      <i class="fas fa-search"></i>
      <div fxHide.lt-lg>{{ searchText_desktop }}</div>
      <div fxHide.gt-md>{{ searchText_mobile }}</div>
    </button>
  </div>

  <div *ngIf="MobileService.isDesktop" fxFlex="20" fxLayout="row" fxLayoutAlign="start center">
    <div style="text-align: center" fxFlex="grow">oder</div>

    <!-- local create button -->
    <button fxFlex="noshrink" class="orange-button create-btn" (appLoginClickGuard)="localGotoCreate()">
      Beitrag erstellen
    </button>
  </div>
</div>
